/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Loading_From_ServerInputs */



/**
* | output |
* | --- |
* | "Loading users from server." |
*
* @param {User_List_Loading_From_ServerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_loading_from_server = /** @type {((inputs?: User_List_Loading_From_ServerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Loading_From_ServerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des utilisateurs depuis le serveur.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando usuarios del servidor.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Carregando usuários do servidor.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento utenti dal server.")
	return /** @type {LocalizedString} */ ("Loading users from server.")
});